import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-pre-shipment-survey',
    templateUrl: './pre-shipment-survey.component.html',
    styleUrls: ['./pre-shipment-survey.component.css'],
    standalone: false
})
export class PreShipmentSurveyComponent implements OnInit {

  preShipmentSurvey: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder) { }

  // TODO: Verify options with Chandu
  surveyReqTypes: string[] = ['After Acceptance', 'Before Acceptance', 'No'];

  // TODO: Verify options with Chandu
  surveyTypes: string[] = ['Onsite', 'By Phone', 'None'];

  ngOnInit() {
  this.preShipmentSurvey = new UntypedFormGroup({
      preMoveSurveyType: new UntypedFormControl(''),
      preMoveSurveyReqd: new UntypedFormControl('')
    });
  }

}
